const templateUrl = require('./edit-payment.html');
const ctrl = require('./edit-payment.controller');

module.exports = function($stateProvider) {
  $stateProvider.state('billing.edit', {
    resolve: {
      billingAddress: ['ogsdk.addressService', '$stateParams',
        (addressService, $stateParams) => addressService.get($stateParams.payment.billingAddressId)
      ]
    },
    params: {
      payment: null
    },
    views: {
      'billing@': {
        templateUrl: templateUrl,
        controller: ctrl,
        controllerAs: '$ctrl'
      }
    }
  });
};

module.exports.$inject = ['$stateProvider'];
